import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { 
  getCourseRecord, fetchCourseRecord, downloadCourseSyllabus,
  getPublicClassList, fetchPublicClassList, fetchCourseIndex, getCourseIndex
} from '../../../store/client'
import { getUser } from '../../../store/alpha'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import { formatValue } from '../../../shared/ui/TableData'
import Button from '../../../shared/ui/Button'
import Image from '../../../shared/ui/Image'
import Text from '../../../shared/ui/Text'
import Link from '../../../shared/ui/Link'
import Grid from '../../../shared/ui/Grid'
import Section from '../../../shared/ui/Section'
import InfoSection from '../../../shared/ui/InfoSection'

import ProviderCard from './ProviderCard'
import PublicClassCard from './PublicClassCard'
import CourseCard from './CourseCard'
import CoursePriceListView from './CoursePriceListView'
import ProjectFormView from './ProjectFormView'
import PublicClassOrderView from './PublicClassOrderView'
import CourseContentsView from './CourseContentsView'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'
import Avatar from '@material-ui/core/Avatar'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import CheckedIcon from '@material-ui/icons/Check'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined'

const styles = theme => ({
  root: {
    position: 'relative'
  },
  courseInfoCard: {

  },
  cardDate: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    //fontWeight: 600,
    //color: '#666'
  },
  courseInfoCardText: {
    fontWeight: 400,
    color: '#444'
  },
  courseInfoCardPrice: {
    fontWeight: 400,
    color: '#444'
  },
  cardAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),    
  },
  cardProviderName: {
    fontWeight: 600,
    color: '#aaa'    
  },
  title: {
    fontSize: theme.typography.h4.fontSize,
    fontWeight: 800,    
  },
  sectionTitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800,
    //color: theme.palette.primary.main
  },
  sectionSubtitle: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 800,
    color: '#777'
  },  
  filterPanel: {
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    width: '100%'
  },
  orderCard: {
    //backgroundColor: theme.palette.primary.main,
    //color: 'white',
    padding: theme.spacing.unit * 2,    
  },
  orderCardPrice: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 800,
    textAlign: 'center'
  },
  orderCardPriceDiscount: {
    fontSize: theme.typography.body2.fontSize,
    textAlign: 'center',
    color: 'red',
    textDecoration: 'line-through'
  },
  orderCardTitle: {
    //color: theme.palette.primary.main,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800,    
  },
  orderCardLabel: {
    //color: theme.palette.primary.main,
    fontSize: theme.typography.body2.fontSize,
    color: '#777'    
  },
  formControl: {
    width: '100%'
  },
  trainerName: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 600,
    textAlign: 'center'    
  }
})

const OrderCard = ({ theme, classes, item, course, publicClasses, user, publicClass, onChange, classType, onChangeType, activeClass }) => {
  // const [classType, setClassType] = useState()
  // const [publicClass, setPublicClass] = useState(activeClass.length > 0 ? activeClass[0].uid : "")
  const [openDialog, setOpenDialog] = useState(false)

  let selectedClass = null
  if(publicClass)
    selectedClass = publicClasses.find(item => item.uid === publicClass)
  
  let classTypes = []
  
  if (publicClasses && publicClasses.length > 0)
    classTypes.push({ key: 'public', label: 'Public' })
    
  if (course.prices && course.prices.length > 0)
    classTypes.push({ key: 'private', label: 'Private' })
    
  const selectedButtonStyle = {
    fontWeight: 800,
    color: 'black'
  }

  let maxRegistrationTime
  let endRegistrationTime

  if (selectedClass) {
    maxRegistrationTime = moment(selectedClass.training_date, 'YYYY-MM-DD').subtract(1, 'day');
    endRegistrationTime = moment(maxRegistrationTime.format('YYYY-MM-DD')+' 17:00', 'YYYY-MM-DD HH:mm');
  }
  
  useEffect(() => {
    // Set default public class
    if (!publicClass && activeClass && activeClass.length > 0)
      onChange(activeClass[0].uid)

    if (!publicClass && activeClass && activeClass.length <= 0 && publicClasses && publicClasses.length > 0)
      onChange(publicClasses[0].uid)
      
    // Set default class type
    if (!classType && classTypes.length)
      onChangeType(classTypes[0].key)
  }, [course, publicClasses])    
  
  if (classTypes.length <= 0)
    return (
    <Paper elevation={12} className={classes.orderCard}>
      <Box>
        <Typography component='h3' className={classes.orderCardTitle}>
          Order Now
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography gutterBottom className={classes.orderCardLabel}>
          Not available to order
        </Typography>
      </Box>      
    </Paper>
    )
  else  
    return (
    <Paper elevation={12} className={classes.orderCard}>
      <Box>
        <Typography component='h3' className={classes.orderCardTitle}>
          Order Now
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography gutterBottom className={classes.orderCardLabel}>
          Class Type
        </Typography>
        <ButtonGroup fullWidth color="primary" aria-label="outlined primary button group">

          { classTypes.map(c => (
              <Button 
                style={ c.key == classType ? selectedButtonStyle : null }
                icon={ c.key == classType && CheckedIcon }
                color={ c.key == classType ? 'black' : '#888888' }
                onClick={() => onChangeType(c.key)}
                >
                { c.label }
              </Button>
            ))
          }

        </ButtonGroup>
      </Box>
      
      { classType == 'public' &&
        <>
          <Box mt={2}>
            <Typography gutterBottom className={classes.orderCardLabel}>
              Date
            </Typography>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                value={ publicClass }
                onChange={(event) => onChange(event.target.value)}
              >

                {publicClasses.map(item =>
                  <MenuItem value={item.uid}>{moment(item.training_date).format('DD MMM YYYY')}</MenuItem>
                )}
                
              </Select>
            </FormControl>
  
            { selectedClass &&
              <Box mt={2}>
                <Typography gutterBottom className={classes.orderCardLabel}>
                  Price
                </Typography>        
                <Typography className={classes.orderCardPrice}>

                  { selectedClass.price_per_participant > 0 ?
                      formatValue(selectedClass.price_per_participant, "currency") + " /pax" 
                    : 'FREE'
                  }

                </Typography>

                { selectedClass.price_per_participant_original > selectedClass.price_per_participant &&
                  <Typography className={classes.orderCardPriceDiscount}>
                      { formatValue(selectedClass.price_per_participant_original, "currency") + " /pax" }
                </Typography>
                }

              </Box>
            }

          </Box>      
          <Box mt={2}>
            <Button variant='contained' fullWidth 
              onClick={() => {
                if (publicClass) {
                  if (user.isLoggedIn)
                    setOpenDialog(true)
                  else
                    alert('You must login before order.')
                } else
                  alert('Please Select Date before order.')
              }}
              disabled={moment().isAfter(endRegistrationTime)}
              >
              { moment().isAfter(endRegistrationTime) ? 'Register Closed' : 'Order' }
            </Button>
            { selectedClass && selectedClass.training_date && moment(maxRegistrationTime).isSameOrAfter(moment().format('YYYY-MM-DD')) &&
              <Box mt={1}>
                <Typography variant='body1'>
                  Please register before {maxRegistrationTime.format('DD MMM YYYY 17:00')}.
                </Typography>
              </Box>
              }
          </Box>      
        </>
      }

      { classType == 'private' &&
        <>
          <Box mt={2}>
            <Typography gutterBottom className={classes.orderCardLabel}>
              Prices
            </Typography>          
            <CoursePriceListView
              course={course}
            />
          </Box>
          <Box mt={2}>
            <Button variant='contained' fullWidth 
            onClick={() => {
                if (!user.isLoggedIn)
                  alert('You must login before order.')
                else {
                  if (!user.companyInfo)
                    alert('You must have company before order.')
                  else
                    setOpenDialog(true)
                }
              }
            }>
              Order
            </Button>
          </Box>        
        </>
      }

      { openDialog &&
      <>
        {classType === 'public' ?
          <PublicClassOrderView 
            publicClass={selectedClass} 
            showDialog={true}
            onClose={() => setOpenDialog(false)}
            user={user}          
          />
        :
          <ProjectFormView 
            course={course} 
            showDialog={true}
            type={'private'}
            onClose={() => setOpenDialog(false)}
          />
        }      
      </>    
      }
      </Paper>
    )
}

const CourseDetailView = ({ theme, classes, ...props }) => {

  const { courseKey, fetchCourse, fetchCourses, fetchPublicClasses, downloadCourseSyllabus, relatedPublicClasses, 
    courses, isFetching, lastFetched, data, user, selectedDate } = props
  
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    fetchCourse()
    fetchPublicClasses()
    fetchCourses()
  }, [courseKey])  
    
  const smUp = useMediaQuery(theme.breakpoints.up('sm'))

  let publicClassList = relatedPublicClasses.lastFetched ? relatedPublicClasses.data.records : []
  let courseList = courses.lastFetched ? courses.data.records : []
  let providerKey = lastFetched ? (data.provider ? data.provider.uid : 0) : 0

  const [publicClass, setPublicClass] = useState(null)
  const [classType, setClassType] = useState(selectedDate ? 'public' : 'private')

  if (!lastFetched)
    return (
      <div className={classes.root}>
        { isFetching &&
          <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
            <CircularProgress size='1.5rem' disableShrink={true} />        
          </Box>
        }      
      </div>
    )

  let filteredPublicClasses = publicClassList.filter(item => item.provider.uid === parseInt(providerKey))
  let filteredCourses = courseList.filter(item => item.provider.uid === parseInt(providerKey))

  const getProviderDetailLink = (row) => {
    return `/provider/${row.uid}`
  }

  const getTrainerDetailLink = (row) => {
    return `/trainer/${row.uid}`
  }

  const getCourseDetailLink = (row) => {
    return `/course/${row.uid}`
  }
  
  return (
    <Box display='flex' flexDirection='column'>
      <Box display='flex' className={classes.root}>
        <Box flexGrow={1}>
          <Box display='flex' alignItems='center'>
            <Box flexGrow={1}>
              <Typography component='h1' className={classes.title}>
                { data.name }
              </Typography>
            </Box>
            { user.isLoggedIn &&
            <Box>
              <CloudDownloadOutlinedIcon 
                onClick={() => {
                  navigationContext.showLoadingDialog(true)
                  downloadCourseSyllabus(() => navigationContext.showLoadingDialog(false))
                }} 
                style={{fontSize:'2rem', cursor:'pointer',color:'rgb(40, 109, 204)'}}
                />
            </Box>
            }
          </Box>
          <Box mt={4} />
          
          <InfoSection gutterBottom
            items={[
              { label: 'Category', value: data.category_name},
              { label: 'Duration', value: data.training_days ? `${data.training_days} Day${data.training_days > 0 ? 's' : ''}` : ''},
              { label: 'Level', value: data.level_name || 'Basic'},
            ]}
            />                      
            
          <Section gutterBottom>
            <Section title="Summary" variant="subsection">
              <Text text={data.summary} format='markdown'/>
            </Section>
          </Section>        
          
          { classType !== 'public' ?
          <>
            { data.trainers &&
              <Section title="Trainer" gutterBottom>
                <Box display='flex' flexDirection='row' flexWrap="wrap" mt={1} mb={1}>
                  { data.trainers.map((item, index) =>
                    <Link to={`/trainer/${item.uid}`}>
                      <Box width='140px' display='flex' 
                        flexDirection='column' 
                        alignItems='center'
                        style={{ 
                          padding: theme.spacing(1)
                        }}
                        >
                        <Avatar alt={item.first_name} src={item.profile_picture_url} 
                          style={{
                            width: '100px',
                            height: '100px'
                          }}
                        />
                        <Box mt={1} />
                        <Typography variant='body1' className={classes.trainerName}>
                          { item.first_name + ' '+ item.last_name }
                        </Typography>                
                      </Box>
                    </Link>
                  )}
                </Box>
              </Section>
            }
          </>
          :
            <Section title="Trainer" gutterBottom>
              <Box display='flex' flexDirection='row' flexWrap="wrap" mt={1} mb={1}>
                { filteredPublicClasses.filter(item => item.uid === publicClass).map((item, index) =>
                  <Link to={`/trainer/${item.trainer.uid}`}>
                    <Box width='140px' display='flex' 
                      flexDirection='column' 
                      alignItems='center'
                      style={{ 
                        padding: theme.spacing(1)
                      }}
                      >
                      <Avatar alt={item.trainer.first_name} src={item.trainer.profile_picture_url} 
                        style={{
                          width: '100px',
                          height: '100px'
                        }}
                      />
                      <Box mt={1} />
                      <Typography variant='body1' className={classes.trainerName}>
                        { item.trainer.first_name + ' '+ item.trainer.last_name }
                      </Typography>                
                    </Box>
                  </Link>
                )}
              </Box>
            </Section>
          }

          <Section title="Syllabus" gutterBottom>
            <CourseContentsView
              course={data}
              user={user}
            />          
          </Section>    
        </Box>
        <Box flexShrink={0} style={{ width: '6%' }} />
        <Box flexShrink={0} style={{ width: '35%' }}>
          { data.primary_image_url &&
            <Box style={{ border: "1px solid #cccccc" }}>
              <Image src={ data.primary_image_url } 
                aspectRatio={1.33}
                />
            </Box>
          }        
          <Box mt={4}>        
            <OrderCard theme={theme} classes={classes}
              course={data}
              publicClasses={publicClassList.filter(item => item.course.uid === parseInt(courseKey))}
              user={user}
              publicClass={publicClass}
              onChange={(value) => setPublicClass(value)}
              classType={classType}
              onChangeType={(value) => setClassType(value)}
              activeClass={selectedDate ? publicClassList.filter(item => item.course.uid === parseInt(courseKey) && item.training_date === selectedDate) : []}
              />
          </Box>        
          
          { data.provider &&
            <Box mt={4}>        
              <Typography component='h3' className={classes.sectionSubtitle}>
                Training Provider
              </Typography>
              <Box mt={2}>        
                <ProviderCard theme={theme} classes={classes}
                  item={data.provider}
                  linkTo={getProviderDetailLink(data.provider)}
                />
              </Box>        
            </Box>
          }
        </Box>
      </Box>
      <Box>
        { filteredCourses.length > 0 &&
        <>
          <Box mt={4} display='flex' alignItems='center'>
            <Box flexGrow={1} className={classes.sectionTitle}>
              Other courses from this training provider
            </Box>
          </Box>
          <Box mt={3}>
            <Grid
              size={'medium'} 
              maxRowCount={1}
              items={filteredCourses}
              renderItem={(item, index) => (
              <CourseCard theme={theme} classes={classes}
                  item={item}
                  linkTo={getCourseDetailLink(item)}
                  target={'_self'}
                  />
              )}
            />
          </Box>
          </>
          }

          { filteredPublicClasses.length > 0 &&
          <>
            <Box mt={4} display='flex' alignItems='center'>
              <Box flexGrow={1} className={classes.sectionTitle}>
                Other public classes from this training provider
              </Box>
            </Box>
            <Box mt={3}>
              <Grid
                size={'medium'} 
                maxRowCount={1}
                items={filteredPublicClasses}
                renderItem={(item, index) => (
                <PublicClassCard theme={theme} classes={classes}
                    item={item}
                    linkTo={getCourseDetailLink(item.course)}
                    />
                )}
              />
            </Box>
          </>
          }
        </Box>
      </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  let courseKey = ownProps.courseKey

  return {
    courseKey,
    ...getCourseRecord(state, courseKey),
    relatedPublicClasses: getPublicClassList(state),
    user: getUser(state),
    courses: getCourseIndex(state, '')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let courseKey = ownProps.courseKey
  
  return {
    fetchCourse: () => {
      dispatch(fetchCourseRecord(courseKey))
    },
    fetchPublicClasses: () => {
      dispatch(fetchPublicClassList(true, {course:courseKey}))
    },
    fetchCourses: () => {
      dispatch(fetchCourseIndex('', null, true))
    },
    downloadCourseSyllabus:(onComplete) =>{
      dispatch(downloadCourseSyllabus(courseKey, onComplete))
    },    
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(CourseDetailView)
)
